function initMainArticleSection(sectionId) {
  function initStickyAtc() {
    const bar = document.getElementById('sticky-atc-' + sectionId);
    if (!bar) return;

    const header = document.querySelector('sticky-header.header-wrapper, .header-wrapper');
    let lastScroll = window.scrollY;

    const updateTop = () => {
      if (!header) return;
      const bottom = header.getBoundingClientRect().bottom;
      bar.style.top = Math.max(0, bottom) + 'px';
    };

    bar.style.transition = 'none';
    updateTop();
    bar.classList.add('sticky-atc--visible');
    bar.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => { bar.style.transition = ''; });

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateTop();
        const current = window.scrollY;
        const scrollingDown = current > lastScroll && current > 0;
        lastScroll = current;
        bar.classList.toggle('sticky-atc--visible', !scrollingDown);
        bar.setAttribute('aria-hidden', String(scrollingDown));
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', updateTop, { passive: true });
    window.addEventListener('load', updateTop, { passive: true });

    if (header && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateTop).observe(header);
    }
  }

  function initAtcButtons() {
    document.querySelectorAll('.atc-btn').forEach((btn) => {
      const originalText = btn.textContent;
      btn.addEventListener('click', () => {
        const ids = (btn.dataset.variantIds || btn.dataset.variantId || '').split(',').filter(Boolean);
        if (!ids.length) return;
        const drawer = document.querySelector('cart-drawer');
        const sectionsToRender = drawer?.getSectionsToRender
          ? drawer.getSectionsToRender().map((s) => s.id)
          : ['cart-drawer', 'cart-icon-bubble'];
        const items = ids.map((id) => ({ id: parseInt(id), quantity: 1 }));
        btn.disabled = true;
        btn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items,
            sections: sectionsToRender,
            sections_url: window.location.pathname
          })
        })
        .then((r) => { if (!r.ok) throw r; return r.json(); })
        .then((response) => {
          btn.textContent = 'Added!';
          if (drawer?.renderContents) {
            response.id = response.items?.[0]?.variant_id ?? ids[0];
            drawer.classList.remove('is-empty');
            drawer.renderContents(response);
          }
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1500);
        })
        .catch(() => {
          btn.disabled = false;
          btn.textContent = 'Error — try again';
        });
      });
    });
  }

  function init() {
    initStickyAtc();
    initAtcButtons();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === sectionId) init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
